import { SelectOptionType } from '@/components/content/SelectBoxTypes'
import { useGetOutboundSchedules } from '@/services/outboundSchedule/useOutboundScheduleQueries'
import { useGetCutOffWarehouses } from '@/services/warehouse/useWareHouseQueries'
import { useCutOffDate } from './useCutOffDate'
import { CutType } from '@/services/outboundSchedule/types'

/**
 *  현재 선택한 시간에 isActive한 warehouse만 옵션으로 노출
 */
export const useAllocationWarehouseOptions = ({ time, cutType }: { time: string; cutType: CutType }): SelectOptionType<string>[] => {
  const { cutOffDate, prevCutOffDate, shipperCode } = useCutOffDate()

  const { options } = useGetCutOffWarehouses()

  const { data: schedulesData } = useGetOutboundSchedules({ date: cutOffDate, shipperCode })
  const { data: prevSchedulesData } = useGetOutboundSchedules({ date: prevCutOffDate, shipperCode })

  const { timeSlots } = schedulesData ?? {}
  const { timeSlots: prevTimeSlots } = prevSchedulesData ?? {}

  const filteredTimeSlots = timeSlots?.filter((timeRow) => timeRow.time < '23:00').map((timeRow) => ({ ...timeRow, date: cutOffDate })) ?? []
  const filteredPrevTimeSlots =
    prevTimeSlots?.filter((timeRow) => timeRow.time >= '23:00').map((timeRow) => ({ ...timeRow, date: prevCutOffDate })) ?? []

  const combinedTimeSlots = [...filteredPrevTimeSlots, ...filteredTimeSlots]

  const isActiveWarehouseCodes =
    combinedTimeSlots
      .find((t) => t.time === time)
      ?.schedules.find((s) => s.cutType === cutType)
      ?.centerSchedules.filter(({ isActive }) => isActive)
      .map(({ warehouseCode }) => warehouseCode) || []

  return options.filter(({ module }) => module === 'MWMS').filter(({ value }) => isActiveWarehouseCodes?.includes(value))
}
